import { render, staticRenderFns } from "./TokenInfo.vue?vue&type=template&id=57da5fc5&scoped=true&"
import script from "./TokenInfo.vue?vue&type=script&lang=js&"
export * from "./TokenInfo.vue?vue&type=script&lang=js&"
import style0 from "./TokenInfo.vue?vue&type=style&index=0&id=57da5fc5&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "57da5fc5",
  null
  
)

component.options.__file = "TokenInfo.vue"
export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib'
import { VCard } from 'vuetify/lib'
import { VCardActions } from 'vuetify/lib'
import { VCardText } from 'vuetify/lib'
import { VCardTitle } from 'vuetify/lib'
import { VChip } from 'vuetify/lib'
import { VDialog } from 'vuetify/lib'
import { VDivider } from 'vuetify/lib'
import { VFlex } from 'vuetify/lib'
import { VImg } from 'vuetify/lib'
import { VLayout } from 'vuetify/lib'
import { VMenu } from 'vuetify/lib'
import { VSpacer } from 'vuetify/lib'
import { VTextField } from 'vuetify/lib'
installComponents(component, {
  VBtn,
  VCard,
  VCardActions,
  VCardText,
  VCardTitle,
  VChip,
  VDialog,
  VDivider,
  VFlex,
  VImg,
  VLayout,
  VMenu,
  VSpacer,
  VTextField,
})
